import { queryOptions } from "@tanstack/react-query";

import type { EnterpriseDashboard, MemberDetail } from "@kansai-ai-hub/api-client";

import { apiClient } from "@/lib/api-client";

export const enterpriseKeys = {
  all: ["enterprise"] as const,
  dashboard: () => [...enterpriseKeys.all, "dashboard"] as const,
  memberDetail: (id: string) => [...enterpriseKeys.all, "member", id] as const,
} as const;

export function enterpriseDashboardQueryOptions() {
  return queryOptions({
    queryKey: enterpriseKeys.dashboard(),
    queryFn: () => apiClient.get<EnterpriseDashboard>("/api/v1/enterprise/dashboard"),
    staleTime: 30_000,
  });
}

/**
 * 会員（応募元組織）のプロフィール。`id` は Organization.id。
 * API は「自社案件に応募してきた会員」だけを返す（それ以外は 404）ので、応募詳細からの
 * 遷移以外でこの query を投げる導線は作らないこと。
 */
export function memberDetailQueryOptions(id: string) {
  return queryOptions({
    queryKey: enterpriseKeys.memberDetail(id),
    queryFn: () => apiClient.get<MemberDetail>(`/api/v1/members/${id}`),
    staleTime: 60_000,
  });
}
